import { colors } from "../common/colors";

export const styles = {
  tabTitle: {
    paddingTop: 8,
    fontSize: 12,
  },
  tabContainer: {
    borderTopColor: "#86BB57",
    borderTopWidth: 2,
    borderTopStyle: "solid",
    margin: 0,
    padding: 0,
    paddingLeft: 0,
    borderBottomColor: "#86BB57",
    borderBottomWidth: 2,
    borderBottomStyle: "solid",
    width: "100%",

    justifyContent: "space-between",
  },
  activeTab: {
    paddingLeft: 0,
    paddingRight: 0,
    color: colors.farm_green500,
    backgroundColor: "white",
    borderRadius: 0,
    boxShadow: "0 0 0 0",
    border: 0,
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "500",
    borderLeft: 1,
    borderLeftColor: colors.farm_gray100,
    borderLeftStyle: "solid",
    width: "100%",
    maxWidth: 174,
    // paddingTop: 10,
    paddingBottom: 10,
    margin: 0,
  },
  unActiveTab: {
    paddingLeft: 0,
    paddingRight: 0,
    fontFamily: "Poppins",
    color: "black",
    backgroundColor: "white",
    borderRadius: 0,
    boxShadow: "0 0 0 0",
    border: 0,
    fontSize: 16,
    fontWeight: "500",
    width: "100%",
    borderLeft: 1,
    borderLeftColor: colors.farm_gray100,
    borderLeftStyle: "solid",
    maxWidth: 174,
    minWidth: 30,
    // paddingTop: 10,
    paddingBottom: 10,
    margin: 0,
  },
  body: {
    background: "#f6f5f7",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    fontFamily: "'Montserrat', sans-serif",
    height: "100vh",
    margin: "-20px 0 50px",
  },
  h1: {
    fontWeight: "bold",
    margin: 0,
  },
  h2: {
    textAlign: "center",
  },
  p: {
    fontSize: "14px",
    fontWeight: 100,
    lineHeight: "20px",
    letterSpacing: "0.5px",
    margin: "20px 0 30px",
  },
  span: {
    fontSize: "12px",
  },
  a: {
    color: "#333",
    fontSize: "14px",
    textDecoration: "none",
    margin: "15px 0",
  },
  button: {
    borderRadius: "20px",
    border: "1px solid #FF4B2B",
    backgroundColor: "#FF4B2B",
    color: "#FFFFFF",
    fontSize: "12px",
    fontWeight: "bold",
    padding: "12px 45px",
    letterSpacing: "1px",
    textTransform: "uppercase",
    transition: "transform 80ms ease-in",
  },
  form: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: "0 50px",
    height: "100%",
    textAlign: "center",
  },
  input: {
    backgroundColor: "#eee",
    border: "none",
    padding: "12px 15px",
    margin: "8px 0",
    width: "100%",
  },
  container: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)",
    position: "relative",
    overflow: "hidden",
    width: "768px",
    maxWidth: "100%",
    minHeight: "480px",
  },
  formContainer: {
    position: "absolute",
    top: 0,
    height: "100%",
    transition: "all 0.6s ease-in-out",
  },
  // GroupTable Component Start
  tableContainer: {
    flexDirection: "row",
    display: "flex",
    width: "80%",
    justifyContent: "space-between",
  },
  // GroupTable Component Ends

  /////////////////////////////////////   MyFarm Starts   /////////////////////////////////
  farmContainer: {
    paddingLeft: 10,
    paddingRight: 10,
    overflow: "hidden",
  },
  farmProfileInfo: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    marginTop: 60,
  },
  farmProfileIcon: {
    width: 70,
    height: 70,
    alignSelf: "center",
    marginBottom: 20,
    borderRadius: 35,
  },
  farmDivider: { marginTop: 40, backgroundColor: "gray" },
  farmInfoTitle: {
    fontSize: 16,
    color: "#2596be",
    fontWeight: "500",
    justifyContent: "center",
    alignSelf: "center",
  },
  farmDivider2: { alignSelf: "center", backgroundColor: "gray" },
  farmDivider3: { width: "50%", marginTop: 10 },
  /////////////////////////////////////   MyFarm Ends   /////////////////////////////////

  /////////////////////////////////////   Community List page Starts   /////////////////////////////////

  communityContainer: { padding: 0, marginTop: 80 },
  communiTitle: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  communiTitleTxt: {
    fontSize: 24,
    fontFamily: "mplus-1c-regular",
    paddingLeft: 6,
    fontWeight: "600",
  },
  communiTitleDescrip: {
    fontFamily: "mplus-1c-regular",
    fontSize: 16,
  },
  createPostBtnBox: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 16,
    display: "flex",
    marginBottom: 14,
  },
  createPostBtn: {
    alignSelf: "center",
    borderRadius: 20,
    backgroundColor: colors.farm_blue200,
  },
  createPostBtnText: { minWidth: 200 },
  communityBox: { padding: "0 20px" },


  /////////////////////////////////////   Community List page Ends   /////////////////////////////////

  /////////////////////////////////////   Facilitator List page Starts   /////////////////////////////////

  createSuggestionBox: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 32,
    display: "flex",
    marginBottom: 14,
  },
  createSuggestionBtn: {
    alignSelf: "center",
    borderRadius: 26.5,
    backgroundColor: colors.farm_blue200,
    width: "300px",
    height: "53px",
  },
  facilitatorDescrip: {
    fontFamily: "mplus-1c-regular",
    fontSize: 16,
    paddingTop: "16px",
    paddingBottom: "4px",
    lineHeight: "28px",
    margin: 0
  },

  /////////////////////////////////////   Community List page Ends   /////////////////////////////////

  /////////////////////////////////////   Intro Page Starts   /////////////////////////////////
  introContainer: {
    backgroundColor: "whitesmoke",
    overflow: "hidden",
    paddingBottom: 30,
  },
  introSliderSec: {
    margin: 30,
    backgroundColor: "white",
    marginTop: 30,
    marginBottom: 30,
    padding: 10,
    paddingTop: 10,
    borderRadius: 20,
    borderColor: colors.farm_green200,
    borderStyle: "solid",
  },
  introSliderTxt: {
    fontFamily: "mplus-1c-bold",
    fontSize: 24,
    margin: 0,
  },
  introSliderDsc: {
    fontFamily: "mplus-1c-regular",
    fontSize: 24,
    margin: 0,
  },
  introSliderImg: {
    // margin: 10,
    backgroundColor: "white",
    height: "100%",
    width: "100%",
    // maxHeight:400,
    maxWidth: 400,
  },
  introSliderBtnSec: {
    width: "100%",
    marginTop: 20,
    paddingBottom: 20,
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    display: "flex",
  },
  introSliderBtn: {
    alignSelf: "center",
    borderRadius: 20,
    backgroundColor: colors.farm_blue200,
  },
  introSliderNextbtn: { minWidth: 200 },
  /////////////////////////////////////   Intro Page Ends   /////////////////////////////////

  /////////////////////////////////////   Detail View Page Starts   /////////////////////////////////
  detailPostDate: {
    color: colors.farm_gray200,
    fontFamily: "mplus-1c-regular",
    fontSize: 12,
  },
  detailListItem: {
    borderTopWidth: 1,
    borderTopColor: colors.farm_gray100,
    borderBottomWidth: 1,
    borderBottomColor: colors.farm_gray100,
  },
  detailVoteStatusTxt: {
    display: "flex",
    alignItems: "center",
    color: colors.farm_green500,
  },
  detailStatusContainer: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
  },
  /////////////////////////////////////   Detail View Page Ends   /////////////////////////////////

  /////////////////////////////////////   DropDown Component Starts   /////////////////////////////////
  dropDownSelected: {
    fontFamily: "mplus-1c-bold",
    justifyContent: "left",
    backgroundColor: colors.farm_white,
  },
  dropDownMenuItem: { fontFamily: "mplus-1c-bold", fontSize: "14pt" },
  /////////////////////////////////////   DropDown Component Ends   /////////////////////////////////

  tagStyle: { backgroundColor: colors.farm_gray200, borderRadius: 2 },

  //////tag input/////
  // gc

  portionBg: {
    backgroundColor: colors.farm_gray15,
    margin: 8,
    borderRadius: 10,
    padding: 8,
  },

  portionMemberListBg: {
    backgroundColor: colors.farm_gray15,
    marginTop: 20,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 20,
    borderRadius: 10,
    padding: 8,
  },
};
